import { ChangeInFeatureStateProps } from "../interface";

const useChangeInFeatureState: ChangeInFeatureStateProps = (
    selectedCompanyFeatures,
    featureState,
    selectedCompanyMetaData: any,
    featuresMetaData: any
) => {
    let featuresToEnable: string[] = [];
    let featuresToDisable: string[] = [];
    for (const featureName of Object.keys(featureState)) {
        if (
            featureState[featureName as keyof typeof featureState] &&
            !selectedCompanyFeatures.includes(featureName)
        ) {
            featuresToEnable.push(featureName);
        } else if (
            !featureState[featureName as keyof typeof featureState] &&
            selectedCompanyFeatures.includes(featureName)
        ) {
            featuresToDisable.push(featureName);
        }
    }

    for (const featureName in selectedCompanyMetaData) {
        if (
            JSON.stringify(selectedCompanyMetaData[featureName]) !==
                JSON.stringify(featuresMetaData[featureName]) &&
            featureState[featureName as keyof typeof featureState] &&
            !featuresToEnable.includes(featureName)
        ) {
            featuresToEnable.push(featureName);
        }
    }
    return [featuresToEnable, featuresToDisable];
};

export default useChangeInFeatureState;
